// NOTE :: Peers with `last_seen` older than this are ignored when counting active tabs (ms).
const LAST_TAB_LOGOUT_ACTIVE_WINDOW_MS = 120_000;

// NOTE :: How often this tab bumps its `last_seen` in the shared localStorage registry (ms).
const LAST_TAB_LOGOUT_HEARTBEAT_MS = 45_000;

// NOTE :: Navigation API `navigate` (reload) must be this close to `pagehide` to count as refresh (ms).
const LAST_TAB_LOGOUT_NAVIGATE_RELOAD_WINDOW_MS = 2_500;

// NOTE :: If F5 / Ctrl+R fires, ignore last-tab logout only when `pagehide` happens within this window (ms).
const LAST_TAB_LOGOUT_KEYBOARD_RELOAD_WINDOW_MS = 2_000;

// NOTE :: If this tab intentionally navigates to another Animals First domain, skip last-tab logout in this window (ms).
const LAST_TAB_LOGOUT_ANIMALSFIRST_NAVIGATION_WINDOW_MS = 4_000;

// NOTE :: Prefix for the localStorage registry.
const LAST_TAB_LOGOUT_STORAGE_PREFIX = 'af-open-tabs:';

// NOTE :: Per-tab stable id for the lifetime of this tab (including refresh)
const LAST_TAB_SESSION_TAB_ID_KEY = 'af-tab-id';

// NOTE :: Set on `pagehide` when skipping logout for reload so a Firefox `unload` handler does not log out.
const LAST_TAB_SKIP_UNLOAD_LOGOUT_KEY = 'af-lt-skip-unload-logout';

// NOTE :: localStorage key prefix for a deferred logout record written on `pagehide`; resolved on next page load.
const LAST_TAB_LOGOUT_PENDING_DEFERRED_KEY = 'af-lt-pending-logout';

function tabRegistryStorageKey(user_id: string): string {
  return `${LAST_TAB_LOGOUT_STORAGE_PREFIX}${user_id}`;
}

export {
  LAST_TAB_LOGOUT_ACTIVE_WINDOW_MS,
  LAST_TAB_LOGOUT_ANIMALSFIRST_NAVIGATION_WINDOW_MS,
  LAST_TAB_LOGOUT_HEARTBEAT_MS,
  LAST_TAB_LOGOUT_KEYBOARD_RELOAD_WINDOW_MS,
  LAST_TAB_LOGOUT_NAVIGATE_RELOAD_WINDOW_MS,
  LAST_TAB_LOGOUT_PENDING_DEFERRED_KEY,
  LAST_TAB_LOGOUT_STORAGE_PREFIX,
  LAST_TAB_SESSION_TAB_ID_KEY,
  LAST_TAB_SKIP_UNLOAD_LOGOUT_KEY,
  tabRegistryStorageKey,
};
